import React from 'react';
import { ChevronRight, Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-b from-primary to-[#0D0520] text-center relative overflow-hidden" data-id="element-90" data-mp="3ucx5fjonnv1b">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse,rgba(124,58,237,0.12)_0%,transparent_70%)] pointer-events-none" data-id="element-91" data-mp="c70wp6v119mz" />
      
      <div className="max-w-[1100px] mx-auto px-5 relative z-10" data-id="element-92" data-mp="m3wx0parupgg">
        <h2 className="font-display text-3xl md:text-5xl lg:text-[52px] font-black leading-tight mb-5 text-white" data-id="element-93" data-mp="h5vimhoajebb">
          Tu vida soñada te está<br data-id="element-94" data-mp="vtqbpz67nkox" />
          <span className="text-gradient-violet" data-id="element-95" data-mp="vu8ezfraiz6c">esperando desde hace tiempo.</span>
        </h2>
        
        <p className="text-lg text-gray-400 max-w-[560px] mx-auto mb-10 leading-relaxed" data-id="element-96" data-mp="qwgmokmqhb1m">
          No dejes que otro mes pase mientras el "termostato de escasez" sigue controlando tu realidad. Por el precio de un café, activa el sistema que cambia tu frecuencia para siempre.
        </p>
        
        <div className="inline-block w-full md:w-auto" data-id="element-97" data-mp="2c6hhwbxxzre7">
          <a href="https://pay.hotmart.com/I106896154S" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && window.fbq) {
            window.fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2.5 w-full bg-gradient-to-br from-violet to-violet-dark text-white font-body text-lg font-bold px-12 py-5 rounded-xl shadow-[0_8px_32px_rgba(124,58,237,0.4)] hover:shadow-[0_12px_40px_rgba(124,58,237,0.6)] hover:-translate-y-0.5 transition-all" data-id="element-98" data-mp="2h37zx4tb4x29">
            <ChevronRight className="w-6 h-6" data-id="element-99" data-mp="39rvopad9m4kk" />
            QUIERO EMPEZAR MI TRANSFORMACIÓN — $9.99
          </a>
          
          <p className="flex items-center justify-center gap-1.5 mt-4 text-[13px] text-gray-500" data-id="element-100" data-mp="3eporruj9uigm">
            <Lock className="w-3.5 h-3.5" data-id="element-101" data-mp="3iqqu4k8hjamt" />
            Pago seguro · Acceso inmediato · Garantía 7 días
          </p>
        </div>
      </div>
    </section>;
}